// Qual aviso de cashback mostrar no menu: 'login' (deslogado), 'pix' (logado sem chave Pix) ou null
const useCashbackNotice = ({ isAuthenticated, user, loadingUser }) => {
    if (!isAuthenticated) return 'login';
    // Evita piscar o aviso de Pix enquanto os dados do usuário carregam
    if (loadingUser) return null;

    const pix = typeof user?.cb_pix === 'string' ? user.cb_pix.trim() : user?.cb_pix;
    return pix ? null : 'pix';
};

export default useCashbackNotice;
